export default __webpack_public_path__ + "static/media/silverCup.1aaa3c6b.svg";